/** Combo (CBS_DROPDOWNLIST) und Label — im Original interfaceCombo_, baudrateCombo_, ... */

export interface ComboItem<T extends string = string> {
  value: T;
  label: string;
}

export interface ComboOptions<T extends string = string> {
  items: readonly ComboItem<T>[];
  value?: T;
  title?: string;
  onChange?: (value: T) => void;
}

export function createCombo<T extends string = string>(options: ComboOptions<T>): HTMLSelectElement {
  const select = document.createElement('select');
  select.className = 'cm-combo';

  for (const item of options.items) {
    const option = document.createElement('option');
    option.value = item.value;
    option.textContent = item.label;
    select.append(option);
  }

  if (options.value !== undefined) select.value = options.value;
  if (options.title !== undefined) select.title = options.title;

  const { onChange } = options;
  if (onChange) {
    select.addEventListener('change', () => onChange(select.value as T));
  }

  return select;
}

export function createLabel(text: string): HTMLSpanElement {
  const label = document.createElement('span');
  label.className = 'cm-label';
  label.textContent = text;
  return label;
}

export function createInput(placeholder = ''): HTMLInputElement {
  const input = document.createElement('input');
  input.className = 'cm-input';
  input.type = 'text';
  input.placeholder = placeholder;
  return input;
}
